// Fiyat etiketini "200.000 ₺" biçiminde gösterir.
// Etikete "TL", "tl" ya da "₺" yazılmış olsa da tekrar etmez; sayı olmayan etiketler ("Teklif ile") olduğu gibi kalır.
export function formatPrice(label) {
  if (label === null || label === undefined) return "";
  const raw = String(label).replace(/₺/g, "").replace(/\bTL\b/gi, "").trim();
  if (!raw) return "";
  // Yalnızca rakam girilmişse (örn. 165000) binlik ayırıcı ekle → 165.000
  if (/^\d+$/.test(raw)) return `${new Intl.NumberFormat("tr-TR").format(Number(raw))} ₺`;
  return /\d/.test(raw) ? `${raw} ₺` : raw;
}

// Aylık kullanım kilometresini "3.000 km / ay" biçiminde gösterir; boşsa "" döner.
export function formatMonthlyKm(km) {
  const n = Number(km);
  if (!km || !Number.isFinite(n) || n <= 0) return "";
  return `${new Intl.NumberFormat("tr-TR").format(n)} km / ay`;
}
